import { Inject, Injectable, Renderer2, RendererFactory2 } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { Resolve } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class GoogleFontResolver implements Resolve<void> {
  private renderer: Renderer2;

  constructor(
    @Inject(DOCUMENT) private document: Document,
    rendererFactory: RendererFactory2
  ) {
    this.renderer = rendererFactory.createRenderer(null, null);
  }

  loadExternalLink(
    url: string,
    options: {
      rel: 'stylesheet' | 'preconnect';
      crossOrigin?: boolean;
    }
  ) {
    const linkElm: HTMLLinkElement = this.renderer.createElement('link');

    linkElm.href = url;
    linkElm.rel = options.rel;

    if (options.crossOrigin) {
      linkElm.crossOrigin = String(options.crossOrigin);
    }

    this.renderer.appendChild(this.document.head, linkElm);
  }

  resolve(): void {
    this.loadExternalLink('https://fonts.googleapis.com', {
      rel: 'preconnect',
    });
    this.loadExternalLink('https://fonts.gstatic.com', {
      crossOrigin: true,
      rel: 'preconnect',
    });
    this.loadExternalLink(
      'https://fonts.googleapis.com/css2?family=Nunito:wght@400;500;600;700;800&display=swap',
      {
        rel: 'stylesheet',
      }
    );
  }
}
